import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {selectBuilding} from 'src/app/state/selectors';
import {filter, map, Observable, startWith} from 'rxjs';
import {BuildingState} from 'src/app/state/reducers';
import {TranslatePipe} from '@brunata-angular/util';
import {SelectBuildingModalComponent} from 'src/app/select-building/select-building-modal/select-building-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LoadComponent} from '@brunata-angular/ui';
import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
} from '@angular/router';
import {getLastChild, getRouteLabel} from '@shared/route-utils';
import {SubMenuComponent} from 'src/app/building/sub-menu/sub-menu.component';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TranslatePipe,
        LoadComponent,
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
    ],
    templateUrl: './building.component.html',
    styleUrl: './building.component.scss',
})
export class BuildingComponent extends SubMenuComponent {
    private readonly modalService = inject(NgbModal);
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);

    readonly buildingState$: Observable<BuildingState> = this.store.select(selectBuilding);

    readonly heading$ = this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        startWith(null),
        map(() => getRouteLabel(getLastChild(this.activatedRoute).snapshot, this.translate)),
    );

    changeBuilding(): void {
        this.modalService.open(SelectBuildingModalComponent, {size: 'xl'});
    }
}
